import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import crossIcon from "Assets/newicons/action/close-x/outline/close-x-outline-16px.svg";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import { instance } from "Actions/AxiosInstance";

import diamondbullet from "Assets/Svg/diamond-bullet.svg";
import downArrowBlue from "Assets/Svg/down-arrow-blue.svg";
import emptracking from "Assets/Svg/emptracking.svg";
import expenseinfo from "Assets/Svg/expense-info.svg";
import menuiconBlue from "Assets/Svg/hamburger-menu-outline-16px-blue.svg";
import hrisinfoimg from "Assets/Svg/hrisinfoimg.svg";
import hropsimg from "Assets/Svg/hrops.svg";
import IconLabel from "Component/Labels/IconLabel";
import EmployeeTracking from "Module/Subscription/Dashboard/Employeetracking";
import Expense from "Module/Subscription/Dashboard/Expense";
import Hrops from "Module/Subscription/Dashboard/Hrops";
import Feedback from "Module/Subscription/Dashboard/Feedback";

import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HRIS from "Module/Subscription/Dashboard/Hris";

class AdminSpace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DrawerOpen: false,
      right: false,
      value: 0,
      objectivedropdownname: "HRIS",
      itemselected: "HRIS Info",
      sortmenu: false,
      sort_anchorEl: null,
      openForm: false,
      success: false,
      locationList: [],
      businessUnits: [],
      departmentList: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.onSortMenuClick = this.onSortMenuClick.bind(this);
    this.sortMenuClose = this.sortMenuClose.bind(this);
    this.closePopper = this.closePopper.bind(this);
    this.openForm = this.openForm.bind(this);
  }

  componentDidMount() {
    this.GetEmployeesDepartmentList();
    this.GetBusinessUnits();
    this.GetOfficeLocationList();
  }

  GetEmployeesDepartmentList() {
    const data = {
      featurekey: "directory",
    };
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        this.setState({ departmentList: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBusinessUnits() {
    const data = {
      featurekey: "directory",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        this.setState({ businessUnits: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetOfficeLocationList() {
    const data = {
      featurekey: "directory",
      subscriptionid: this.props.subscription.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        this.setState({ locationList: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  sortMenuClose() {
    this.setState({ sortmenu: false, searchValue3: null });
  }

  onSortMenuClick(event) {
    this.setState({
      sortmenu: !this.state.sortmenu,
      sort_anchorEl: event.currentTarget,
    });
  }

  closePopper() {
    this.setState({ sortmenu: false });
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
      openForm: false,
      success: false,
    });
  }

  openForm() {
    this.setState({
      openForm: true,
      success: false,
    });
  }

  OnTabChange = (event, value) => {
    this.setState({ value });
  };

  setTabValue(value) {
    this.setState({ value });
  }

  handleChange(name, e, index) {
    const { empdata } = this.state;
    empdata[index][name] = e;
    this.setState({
      empdata,
    });
  }

  render() {
    return (
      <div className="admin-space">
        <div
          style={{
            padding: "8px 12px",
            borderRadius: 4,
            backgroundColor: "#f7f8f8",
            display: "inline-flex",
          }}
          onClick={this.onSortMenuClick}
        >
          <p className="small-dark t-bold margin-right-16">
            {this.state.objectivedropdownname}
          </p>
          <img src={menuiconBlue} className="margin-right-8"></img>
          <img src={downArrowBlue}></img>
        </div>
        <Popover
          open={this.state.sortmenu}
          anchorEl={this.state.sort_anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClick={this.closePopper}
          className="margin-top-8"
        >
          <Paper style={{ width: 546, display: "flex", minHeight: 322 }}>
            <div style={{ width: "30%", borderRight: "solid 1px #ddd" }}>
              <List>
                <ListItem
                  button
                  className="padding-top-0 padding-bottom-0 cursor-pointer admin-space-option"
                  onClick={() =>
                    this.setState({ objectivedropdownname: "HRIS" })
                  }
                  onMouseOver={() =>
                    this.setState({ itemselected: "HRIS Info" })
                  }
                  onMouseOut={() =>
                    this.setState({ itemselected: "HRIS Info" })
                  }
                  style={
                    this.state.itemselected == "HRIS Info"
                      ? { background: "#edf5fd" }
                      : {}
                  }
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">HRIS</span>
                  </ListItemText>
                </ListItem>
                <ListItem
                  button
                  className="padding-top-0 padding-bottom-0 cursor-pointer admin-space-option"
                  onClick={() =>
                    this.setState({
                      objectivedropdownname: "Employee tracking",
                    })
                  }
                  onMouseOver={() =>
                    this.setState({
                      itemselected: "Employee tracking Info",
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      itemselected: "HRIS Info",
                    })
                  }
                  style={
                    this.state.itemselected == "Employee tracking Info"
                      ? { background: "#edf5fd" }
                      : {}
                  }
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">
                      Employee tracking
                    </span>
                  </ListItemText>
                </ListItem>
                <ListItem
                  button
                  className="padding-top-0 padding-bottom-0 cursor-pointer admin-space-option"
                  onClick={() =>
                    this.setState({ objectivedropdownname: "Expense" })
                  }
                  onMouseOver={() =>
                    this.setState({ itemselected: "Expense Info" })
                  }
                  onMouseOut={() =>
                    this.setState({ itemselected: "HRIS Info" })
                  }
                  style={
                    this.state.itemselected == "Expense Info"
                      ? { background: "#edf5fd" }
                      : {}
                  }
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Expense</span>
                  </ListItemText>
                </ListItem>
                <ListItem
                  button
                  className="padding-top-0 padding-bottom-0 cursor-pointer admin-space-option"
                  onClick={() =>
                    this.setState({ objectivedropdownname: "HR Ops" })
                  }
                  onMouseOver={() =>
                    this.setState({ itemselected: "HR Ops Info" })
                  }
                  onMouseOut={() =>
                    this.setState({ itemselected: "HRIS Info" })
                  }
                  style={
                    this.state.itemselected == "HR Ops Info"
                      ? { background: "#edf5fd" }
                      : {}
                  }
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">HR Ops</span>
                  </ListItemText>
                </ListItem>
              </List>
            </div>
            <div
              className="padding16"
              style={{ width: "70%", position: "relative" }}
            >
              <div
                style={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  cursor: "pointer",
                }}
                onClick={this.closePopper}
              >
                <img src={crossIcon}></img>
              </div>
              {this.state.itemselected == "HRIS Info" && (
                <div className="margin-top-8">
                  <p className="small-dark margin-bottom-16">
                    Stats about the humans of your organization represented in
                    easy to digest graphs.
                  </p>
                  <div
                    style={{
                      padding: "16px 64px",
                      backgroundColor: "#f9f9f9",
                      margin: "0 -16px",
                      marginBottom: 16,
                    }}
                  >
                    <img src={hrisinfoimg}></img>
                  </div>
                  <div
                    className="display-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <IconLabel
                        label="Employee count"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Request statistics"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Employee retention"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                    <div>
                      <IconLabel
                        label="Hires and exits"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Attrition rate"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                  </div>
                </div>
              )}
              {this.state.itemselected == "Employee tracking Info" && (
                <div className="margin-top-8">
                  <p className="small-dark margin-bottom-16">
                    See attendance and leave patterns to manage the
                    organization’s resources better.
                  </p>
                  <div
                    style={{
                      padding: "16px 64px",
                      backgroundColor: "#f9f9f9",
                      margin: "0 -16px",
                      marginBottom: 16,
                    }}
                  >
                    <img src={emptracking}></img>
                  </div>
                  <div
                    className="display-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <IconLabel
                        label="Leave stats"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Leaves taken"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Workforce availability"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                    <div>
                      <IconLabel
                        label="Leave distribution"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Attendance stats"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                  </div>
                </div>
              )}
              {this.state.itemselected == "Expense Info" && (
                <div className="margin-top-8">
                  <p className="small-dark margin-bottom-16">
                    Monitor employee expenditure pattern and get insights on
                    compensator performance.
                  </p>
                  <div
                    style={{
                      padding: "16px 64px",
                      backgroundColor: "#f9f9f9",
                      margin: "0 -16px",
                      marginBottom: 16,
                    }}
                  >
                    <img src={expenseinfo}></img>
                  </div>
                  <div
                    className="display-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <IconLabel
                        label="Employee expenditure"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Advance wallet"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Expense heatmap"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                    <div>
                      <IconLabel
                        label="Compensator stats"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Unclaimed balance"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Expense distribution"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      />
                    </div>
                  </div>
                </div>
              )}
              {this.state.itemselected == "HR Ops Info" && (
                <div className="margin-top-8">
                  <p className="small-dark margin-bottom-16">
                    Make your work easier with insights from various HR
                    Operations.
                  </p>
                  <div
                    style={{
                      padding: "16px 64px",
                      backgroundColor: "#f9f9f9",
                      margin: "0 -16px",
                      marginBottom: 16,
                    }}
                  >
                    <img src={hropsimg}></img>
                  </div>
                  <div
                    className="display-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <IconLabel
                        label="Most used checklists"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      {/* <IconLabel
                        label="Advance wallet"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Expense heatmap"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      /> */}
                    </div>
                    <div>
                      <IconLabel
                        label="On-going checklists"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      {/* <IconLabel
                        label="Unclaimed balance"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                        className="margin-bottom-16"
                      />
                      <IconLabel
                        label="Expense distribution"
                        img={diamondbullet}
                        labelClassNames="extra-small-dark t-bold"
                        iconHeight="16"
                      /> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Paper>
        </Popover>
        <Grid container className="margin-top-24">
          <Grid item sm={12} md={12}>
            {this.state.objectivedropdownname == "HRIS" && (
              <HRIS {...this.props} {...this.state} openForm={this.openForm} />
            )}
            {this.state.objectivedropdownname == "Employee tracking" && (
              <EmployeeTracking
                {...this.props}
                {...this.state}
                openForm={this.openForm}
              />
            )}
            {this.state.objectivedropdownname == "Expense" && (
              <Expense
                {...this.props}
                {...this.state}
                openForm={this.openForm}
              />
            )}
            {this.state.objectivedropdownname == "HR Ops" && <Hrops />}
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={this.state.openForm}
          onClose={this.handleClickAway}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer width30 padding15",
          }}
        >
          <DrawerHeader
            header="Dashboard feedback"
            isbackarrow={false}
            closeDrawer={this.handleClickAway}
          />
          <Feedback handleClickAway={this.handleClickAway} {...this.props} />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(AdminSpace));
